export class UserInfos {
    firstname: string;
    lastname: string;
    acronymName: string;

    constructor(firstname: string, lastname: string){
        this.firstname = firstname;
        this.lastname = lastname;
        this.acronymName = this.acronym();
    }
    
    acronym(): string {
        return this.firstname.slice(0, 1) + this.lastname.slice(0, 1);
    }
}